import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';

import {mcpEntitlementsStateSelector} from './mcp-entitlements-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {EntitlementsFilters, ResourceView} from 'src/modules/entitlements/typedef';

export const mcpEntitlementsSlice = getCachedTableDataSlice<
    ResourceView[],
    undefined,
    undefined,
    EntitlementsFilters
>('mcpEntitlements');

export const mcpEntitlementsActions = mcpEntitlementsSlice.actions;
const mcpEntitlementsCacheSelector: CachedTableCacheSelector<ResourceView[]>
    = state => state.accountPage.tabs.mcpEntitlements.entitlements.cache;
export const mcpEntitlementsDataSelector: CachedTableDataSelector<ResourceView[]>
    = state => state.accountPage.tabs.mcpEntitlements.entitlements;
export const mcpEntitlementsResultSelector = getCachedTableResultSelector(
    mcpEntitlementsCacheSelector,
    mcpEntitlementsStateSelector,
);
